import { Box, Button, Grid, Typography } from "@mui/material"
import { useTranslation } from "react-i18next"
import { AddUserModal, DataModal } from "./types"
import { useMemo, useState } from "react"
import { useStyles } from "./styles"
import { useRefs } from "../../../../../../hooks/useReactHookModified"
import { MessageUsersAdded, MessageUsersExisted } from "../../../../../questionnaire/pages/permission/components/messages"
import { CustomPaper } from "../../../../../../components/CustomPaper"
import Loader from "../../../../../../components/loader"
import { AddUsersStep, Step1Ref } from "../addUsersStep"
import { FiltersFloat } from "../../../../../logbook/pages/main/components/access/components/filtersFloat"
import SimpleModal from "../../../../../../components/modal/simpleModal"

const AddUsersFiles = (props: AddUserModal) => {

  const { t } = useTranslation()
  const styles = useStyles()
  const { refsByKey, setRef } = useRefs<Step1Ref>()
  const [usaerSelecteds, setUserSelecteds] = useState<(string | number)[]>([])
  const [error, setError] = useState(false)
  const [data, setData] = useState<DataModal>({
    step1: { selects: [], },
    userAlreadyLinked: [],
    usersAmmount: 0
  })

  const closeModalPermissions = () => {
    resetData({ loadSuccess: true, all: true })
    props.close()
  }
  const messageComponent = useMemo(() => {
    if (!data.usersAmmount && !error) return undefined
    if (error) return <MessageUsersExisted return={() => {
      closeModalPermissions()
      setError(false)
    }} />
    return <MessageUsersAdded usersAmmount={data.usersAmmount} return={closeModalPermissions} backText={t('filesManager.titles.backToTableUser')} />
  }, [data.usersAmmount, error])
  /**
   * @returns return the list of users filtering the users than were added to the access questionnaire list
   */

  const userList = useMemo(() => props.userList?.filter(item => !data.userAlreadyLinked?.some(itemStep => itemStep == item.id)), [props.userList, data.userAlreadyLinked])
  const [modal, setModal] = useState<{
    open: boolean
    title: string
    description: string
    confirm: () => void
    cancel?: () => void
  }>({
    open: false,
    title: '',
    description: '',
    confirm: () => { }
  })

  /**
   * @param payload catch a object 
   * @object { loadSuccess: boolean; amountOfUserAdded?: number }
   * @param payload.loadSuccess if the response is true restart all the data
   * @param payload.amountOfUserAdded ammount of users than were added to access questionnaire list
   */
  const resetData = (payload: {
    loadSuccess: boolean;
    amountOfUserAdded?: number
    all?: boolean
  }) => {
    if (payload.loadSuccess) {

      if (!payload.amountOfUserAdded) {
        const refStep1 = (refsByKey['step1'] as Step1Ref)

        if (refStep1?.restart) {
          refStep1.restart()
        }
      }
      setUserSelecteds([])
      /**
      * @description cleean the locale data and save the users selectecs to dont added to the list of users
      */
      const newUserList = payload?.all ? [] : Array.from(new Set([...data.step1.selects, ...data.userAlreadyLinked]))
      setData(prev => ({
        ...prev,
        step1: { selects: [] },
        usersAmmount: payload.amountOfUserAdded,
        userAlreadyLinked: newUserList
      }))

    } else {
      setError(true)
    }
  }

  /**
   * @description get the permissions and the list of users selecteds
   */
  const finished = () => {

    const refStep1 = (refsByKey['step1'] as Step1Ref)
    let selects = data.step1.selects

    if (refStep1?.getSelects) {
      selects = refStep1.getSelects()
    }

    const userListLocale = userList.filter(item => selects.includes(item.id))
    /**
    * @description if the endpoint is successfull execute the resetData
    */
    props.loadData.onClick(userListLocale, resetData)
  }
  /**
   * @description close the modal of confirmation
   */
  const closeModal = () => { setModal(prev => ({ ...prev, open: false })) }

  /**
 * @description apply filters to get the list of users
 */

  const searchUsers = () => {
    const refStep1 = (refsByKey['step1'] as Step1Ref)
    let selectsLocale: (string | number)[] = data.step1.selects

    if (!!refStep1?.getSelects) {
      selectsLocale = refStep1?.getSelects()
    }

    if (!selectsLocale?.length) {
      props.searchButton.onClick()
    } else {
      setModal(prev => ({
        ...prev,
        open: true,
        title: t("general.userFilterWarningTitle"),
        description: t("general.userFilterWarningDescription"),
        cancel: closeModal,
        confirm: () => {
          props.searchButton.onClick()
          resetData({ loadSuccess: true })
          closeModal()
        }
      }))
    }
  }


  return (<>

    <SimpleModal
      open={modal.open}
      close={() => { closeModal() }}
      removeClose={!modal?.cancel}
      title={modal.title}
      description={modal.description}
      buttonText={t('general.confirm')}
      cancelText={t('general.cancel')}
      back={modal?.cancel ?? undefined}
      next={modal.confirm ?? closeModal}
    />

    <CustomPaper elevation={0} sx={{ height: '100%' }}>
      <Box sx={styles.permissionTable({ loading: !!props.searchButton?.loading })}>
        {
          !!props.searchButton.loading ? <Loader /> : (
            <>
              <Box sx={[styles.goBack, styles.alignItems]}>
                {/* <Box >
                  <Typography variant='subtitle_grey' fontWeight={'bold'}>{t('filesManager.titles.selectUsersToAdd')}</Typography>
                </Box> */}
                <Box sx={styles.flex}>
                  <Typography sx={styles.userSelected({ haveUser: Boolean(usaerSelecteds?.length) })}>
                    <span>{usaerSelecteds?.length ?? 0}</span> {t('general.selectedUsers')}
                  </Typography>
                  <Button variant="contained" disabled={!usaerSelecteds?.length} onClick={() => { finished() }}>{t('general.add')}</Button>
                </Box>
              </Box>

              <AddUsersStep
                ref={element => {
                  setRef(element, 'step1')
                  return refsByKey['step1']
                }}
                userSeclecteds={(value) => {
                  setUserSelecteds(value)
                }}
                selects={data.step1.selects}
                message={messageComponent}
                row={userList ?? []}
                addMessage={props.addMessage}
              />
            </>
          )
        }
      </Box>
    </CustomPaper>

    <FiltersFloat title={t('general.filterBy')} cleanFilter={props.cleanFilter} count={props.counter} right={-74} top={0} searchButton={{ disabled: false/* props.searchButton.disabled */, loading: false/* !!loadings.search */, onClick: searchUsers }}>
      {props.rigthItem}
    </FiltersFloat>
  </>)
}

export { AddUsersFiles }